import EnumDataSource from "utils/enum-data-source.util";
import { NON_BREAKABLE_SPACE } from "./common";
import { misc, neutral } from "app/themes/colors";
import { grey } from "@mui/material/colors";

export const TASKS_CREATED_BY_ME = "1";
export const TASKS_ASSIGNED_TO_ME = "2";
export const MY_COMPLETED_TASKS = "3";
export type TASKS_TYPE =
  | typeof TASKS_CREATED_BY_ME
  | typeof TASKS_ASSIGNED_TO_ME
  | typeof MY_COMPLETED_TASKS;

export const TASK_PRIORITY_NOT_SET = 0;
export const TASK_PRIORITY_LOW = 4;
export const TASK_PRIORITY_MEDIUM = 3;
export const TASK_PRIORITY_HIGH = 2;
export const TASK_PRIORITY_URGENT = 1;

const taskPriorities = {
  [TASK_PRIORITY_NOT_SET]: `Not${NON_BREAKABLE_SPACE}Set`,
  [TASK_PRIORITY_LOW]: "Low",
  [TASK_PRIORITY_MEDIUM]: "Medium",
  [TASK_PRIORITY_HIGH]: "High",
  [TASK_PRIORITY_URGENT]: "Urgent",
};

export const TASK_PRIORITIES = new EnumDataSource(taskPriorities);
export const TASK_PRIORITY_OPTIONS = [
  {
    value: TASK_PRIORITY_NOT_SET,
    label: taskPriorities[TASK_PRIORITY_NOT_SET],
  },
  {
    value: TASK_PRIORITY_LOW,
    label: taskPriorities[TASK_PRIORITY_LOW],
  },
  {
    value: TASK_PRIORITY_MEDIUM,
    label: taskPriorities[TASK_PRIORITY_MEDIUM],
  },
  {
    value: TASK_PRIORITY_HIGH,
    label: taskPriorities[TASK_PRIORITY_HIGH],
  },
  {
    value: TASK_PRIORITY_URGENT,
    label: taskPriorities[TASK_PRIORITY_URGENT],
  },
];

export const TASK_STATUS_TODO = 1;
export const TASK_STATUS_IN_PROGRESS = 2;
export const TASK_STATUS_COMPLETED = 3;
export const TASK_STATUS_CANCELLED = 4;

export const TASK_STATUS_COLORS: Record<string, string> = {
  [TASK_STATUS_TODO]: misc.selectedMenuitem,
  [TASK_STATUS_IN_PROGRESS]: misc.darkYellow,
  [TASK_STATUS_COMPLETED]: misc.sunoGreen,
  [TASK_STATUS_CANCELLED]: neutral[600],
};

export const TASK_STATUSES = new EnumDataSource({
  [TASK_STATUS_TODO]: "To Do",
  [TASK_STATUS_IN_PROGRESS]: "In Progress",
  [TASK_STATUS_COMPLETED]: "Completed",
  [TASK_STATUS_CANCELLED]: "Cancelled",
});

export const TASK_PRIORITY_COLORS = new EnumDataSource({
  [TASK_PRIORITY_NOT_SET]: grey[900],
  [TASK_PRIORITY_URGENT]: "#F44336",
  [TASK_PRIORITY_HIGH]: "#ff7043",
  [TASK_PRIORITY_MEDIUM]: "#FBC02D",
  [TASK_PRIORITY_LOW]: "#4CAF50",
});

export const TASK_BACKGROUND_PRIORITY_COLORS = new EnumDataSource({
  [TASK_PRIORITY_NOT_SET]: "",
  [TASK_PRIORITY_URGENT]: "#ffebee99",
  [TASK_PRIORITY_HIGH]: "#fbe9e799",
  [TASK_PRIORITY_MEDIUM]: "#fff8e199",
  [TASK_PRIORITY_LOW]: "#E8F5E999",
});

export const TASK_NEUTRAL_BACKGROUND_COLOR = "#F0E4FC";
